@if (configs) {
	@for (c of configs; track c.tracker) {
		<ivva-filter-box [config]="c"></ivva-filter-box>
	}
}
